import _ from 'lodash';
import {
  MESSAGES_SHOW,
} from './types';

export default function(state = {}, action) {
  switch (action.type) {
    case MESSAGES_SHOW:
      return { ...state, time: new Date().getTime(), message: action.payload  } ;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/data/messages/reducer.js